import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { ClientsService } from '../../services/clients.service';
import { CountriesService } from '../../services/countries.service';
import { EspecificationService } from '../../services/especification.service';
import { ClientsSpecificationsService } from '../../services/clientsSpecifications.service';
import { Client } from '../../model/Client';
import { FilterUrlService } from '../../services/filter-url.service';

@Component({
  selector: 'cliente',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ClientesComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public primeracarga:boolean;
  public load:number;
  public isopen:boolean;
  public alert:string;
  public data_list:any[];
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public countries:any;
  public especificaciones:any[];
  public mostrar_checksbox:boolean;
  public esp_array_client:any[];
  public settings = {
    columns:{
      rut: { header: "Rut", type:"text", filter: { visible:true }},
      name: { header: "Nombre", type:"text" , filter: { visible:true }},
      email: { header: "Email", type:"text" , filter: { visible:true }},
      address: { header: "Direccion", type:"text" , filter: { visible:true }},
      contact: { header: "Contacto", type:"text" , filter: { visible:true }},
    },
    actions:{
      edit: true,
      view: false,
      delete: false
    }
  };

  constructor(private _clientspecificationService:ClientsSpecificationsService ,
    private _specificationService:EspecificationService ,
    private _countriesService:CountriesService,
    private _clientService:ClientsService,
    private _loaddata: LoadService,
    private _filter: FilterUrlService ) {
    this.isopen = false;
    this.primeracarga = false;
    this.alert = "";
    this.especificaciones = [];
    this.esp_array_client = [];
    this.mostrar_checksbox = false;
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1"),
      'rut': new FormControl(''),
      'name': new FormControl(null,Validators.required),
      'email': new FormControl(null),
      'address': new FormControl(null),
      'contact': new FormControl(null,Validators.required),
      'phone': new FormControl(''),
      'country_id': new FormControl(1,Validators.required)
    });
    this.signupForm.valueChanges.subscribe(data=>{
      console.log("Formulario:", data);
    })
    this.loadCountries();
  }

  loadDataFiltered(filters){
      this.isopen = true;
      this.alert = 'Cargando información.';
      this._loaddata.loadChange(90);

      this._clientService.getDataFiltered(filters)
      .subscribe(
        (response:any) => {
          this.cleanForm();
          this.data_list = response.data;
          this.links = response.links;
          this.meta = response.meta;
          this._loaddata.loadChange(100);
          this.alert = "Carga Correcta."
          this.isopen =true;
          this.onClosedAutomatic();
          if(this.primeracarga === false){
            this.primeracarga = !this.primeracarga;
          }
        },
        (error) => {
          if(error.status == 0){
            this.alert = 'Busqueda sin resultados.';
            this.onClosedAutomatic();
          }
          else{
            this.showError(error.error.error);
          }
        }
      );
    }

  /**
  * carga el listado de paises
  */
  loadCountries():void{
    this.isopen = true;
    this.alert = 'Cargando paises.';
    this._loaddata.loadChange(15);

    this._countriesService.getAll().subscribe((response:any) => {
      this.countries = response.data;
      this.loadSpecifications();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  /**
  * carga el listado de todas las especificaciones
  */
  loadSpecifications():void{

    this._loaddata.loadChange(35);
    this.isopen = true;
    this.alert = 'Cargando especificaciones.';

    this._specificationService.getAll().subscribe((response:any) => {
      this.especificaciones = response.data;
      for(let item of this.especificaciones){
        item.checked = false;
      }
      console.log("Especificaciones:",this.especificaciones);
      // for (let i of response.data) {
      //   const control = new FormGroup({
      //     'id': new FormControl(i.id),
      //     'number': new FormControl(i.attributes.number),
      //     'check': new FormControl(false)
      //   });
      //   console.log("control: ",control);
      //   (<FormArray>this.signupForm.get('especificaciones')).push(control);
      //   if(this.signupForm.get('especificaciones').value.length == this.especificaciones.length){
      //     this.mostrar_checksbox = true;
      //     console.log("valor mostrar 2:",this.mostrar_checksbox);
      //   }
      // }
      // console.log("largo especificaciones:",this.signupForm.get('especificaciones').value.length);


      this.loadData();
    },
    (error) => {
      console.log("Error:",error.error.error);
      this.showError(error.error.error);
    });
  }

  cambiarEspecificacion(item){
    console.log("item:",item);
    item.checked = !item.checked;
    console.log("especificaciones al clickear: ",this.especificaciones);
  }

  /**
  * carga el listado de todas las especificaciones almacenadas anteriormente.
  */
  loadSpecificationsLocal():void{
    console.log("valor mostrar:",this.mostrar_checksbox);
    for (let i of this.especificaciones) {
      const control = new FormGroup({
        'id': new FormControl(i.id),
        'number': new FormControl(i.attributes.number),
        'check': new FormControl(false)
      });
      (<FormArray>this.signupForm.get('especificaciones')).push(control);

      if(this.signupForm.get('especificaciones').value.length == this.especificaciones.length){
        this.mostrar_checksbox = true;
        console.log("valor mostrar 2:",this.mostrar_checksbox);
      }
    }
  }

  /**
  * Carga el listado de clientes.
  */
  loadData():void{
    this._loaddata.loadChange(90);
    this.isopen = true;
    this.alert = 'Cargando clientes.';

    this._clientService.get().subscribe(
      (response:any) => {
        //this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

  /**
  * Envia a la BD los datos del formulario.
  */
  saveForm():void{
    for(let item of this.especificaciones){
      if(item.checked == true){
        this.esp_array_client.push({'id':item.id});
      }
    }

    console.log('Especificaciones a enviar: ', this.esp_array_client);

    this.alert = "Almacenando cliente";
    this.isopen =true;
    this._loaddata.loadChange(40);
    let prov = this._clientService.transformData(this.signupForm.value);
    console.log("body crear cliente:", prov);
    let prov2 = this._clientspecificationService.transformData2(this.esp_array_client);
    console.log("body cliente_especificacion:", prov2);
    //let prov2 = this._clientspecificationService.transformData((<FormArray>this.signupForm.get('especificaciones')).controls);
    this._clientService.save(prov).subscribe(
      (response:any) =>{
        this._clientspecificationService.save(prov2,response.id).subscribe(
          (response:any) =>{
            this.restablecerEspecificaciones();
            this._loaddata.loadChange(60);
            this.hideChildModal();
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
        (error) => {
          this.showError(error.error.error);
        }
    );
    this.onClosedAutomatic();
  }

  restablecerEspecificaciones(){
    for(let item of this.especificaciones){
      if(item.checked == true){
        item.checked = false;
      }
    }

    this.esp_array_client = [];

    this.cleanForm();
  }

  /**
  * Envia a la BD los datos a actualizar.
  */
  updateForm():void{
    this.alert = "Actualizando cliente.";
    this.isopen =true;
    this._loaddata.loadChange(35);

    for(let item of this.especificaciones){
      if(item.checked == true){
        this.esp_array_client.push({'id':item.id});
      }
    }

    let htmlbody = this._clientService.transformData(this.signupForm.value);
    //let htmlbody2 = this._clientspecificationService.transformData((<FormArray>this.signupForm.get('especificaciones')).controls);
    let htmlbody2 = this._clientspecificationService.transformData2(this.esp_array_client);
    let url = this.data_list[this.item_to_update]['links'].self;

    this._clientService.update(url, htmlbody).subscribe(
      data => {
        this._clientspecificationService.update(this.data_list[this.item_to_update].id, htmlbody2).subscribe(
          data => {
            this.restablecerEspecificaciones();
            this._loaddata.loadChange(70);
            this.hideChildModal();
            this.alert = "Elemento actualizado.";
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Elimina la fila seleccionada de la BD
  * @param  data id de la fila a eliminar
  */
  deleteItem(data):void{
    this.alert = "Eliminando cliente.";
    this.isopen = true;
    this._loaddata.loadChange(35);

    this._clientService.delete(data.url).subscribe(
      (response:any) => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento eliminado.";
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }
  /**
  * Carga la información de una fila en el formulario.
  * @param  index Indice de la fila que se carga en el formulario.
  */
  showEditForm(index) {
    this.isopen = true;
    this.alert = 'Cargando especificaciones del cliente.';
    this._loaddata.loadChange(35);

    this.cleanForm();
    this.item_to_update = index;
    let item = this.data_list[index];

    this.signupForm.patchValue({
      'id': item.id,
      'rut': item.attributes.rut,
      'name': item.attributes.name,
      'email': item.attributes.email,
      'address': item.attributes.address,
      'contact': item.attributes.contact,
      'phone': item.attributes.phone,
      'country_id': item.attributes.country_id
    });

    for(let item of this.especificaciones){
      item.checked = false;
    }

    this._clientspecificationService.getAll(item.id).subscribe(
      (response:any) => {
        console.log("Especificaciones del cliente: ",response);
        for(let item of response.data){
          for(let item2 of this.especificaciones){
            if(item.id == item2.id ){
              item2.checked = true;
            }
          }
        }
      // for(let j of response.data){
      //   for (let i of (<FormArray>this.signupForm.get('especificaciones')).controls) {
      //     if(j.id == i.value.id){
      //       i.patchValue({
      //         'check':true
      //       });
      //       break;
      //     }
      //   }
      // }
      this._loaddata.loadChange(100);
      this.alert = 'Carga finalizada.';
      this.showChildModal("Actualizar");
      this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Muestra el modal para crear o actualizar segun corresponda.
  * @param tipo si es crear o actualizar
  */
  showChildModal(tipo:string): void {
    if(tipo === "Crear"){
      this.title = "Crear Cliente";
      this.isNew = true;
    } else if(tipo === "Actualizar"){
      this.title = "Actualizar Cliente";
      this.isNew = false;
    }
    this.lgModal.show();
  }

  /**
  * Agrega o elimina del arreglo especificaciones relacionadas con el cliente
  * @param item especificacion que se quiere agregar o no segun el check.
  */
  onChangeSpecification(pos:any):void{
    (<FormArray>this.signupForm.get('especificaciones')).controls[pos].patchValue({
      'check': !(<FormArray>this.signupForm.get('especificaciones')).value[pos].check
    });
  }

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }

  /**
  * Limpia el formulario para volver a utilizarlo.
  */
  // cleanForm():void{
  //   this.signupForm.reset();
  //   this.signupForm = new FormGroup({
  //     'id': new FormControl("-1"),
  //     'rut': new FormControl(''),
  //     'name': new FormControl(null,Validators.required),
  //     'email': new FormControl(null),
  //     'address': new FormControl(null),
  //     'contact': new FormControl(null,Validators.required),
  //     'phone': new FormControl(''),
  //     'country_id': new FormControl(1,Validators.required),
  //     'especificaciones':new FormArray([])
  //   });
  //   this.loadSpecificationsLocal();
  // }
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'id': new FormControl("-1"),
      'rut': new FormControl(''),
      'name': new FormControl(null,Validators.required),
      'email': new FormControl(null),
      'address': new FormControl(null),
      'contact': new FormControl(null,Validators.required),
      'phone': new FormControl(''),
      'country_id': new FormControl(1,Validators.required)
    });
    //this.loadSpecificationsLocal();
  }

  /**
  * Actualiza el listado por la paginacion
  * @param data nuevo listado o mensaje de error.
  */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/clientes/clientes.component.ts